import { render } from "./AssignEmployeeDutyView.vue?vue&type=template&id=afddd5c8&ts=true"
import script from "./AssignEmployeeDutyView.vue?vue&type=script&lang=ts"
export * from "./AssignEmployeeDutyView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__